<template>
    <app-page-options-list :options="filteredOptions" />
</template>
<script>
    import PageOptionsList from '../../UI/Controls/PageOptions/PageOptionsList.vue';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            appPageOptionsList: PageOptionsList
        },
        data() {
            return {
                options: [
                    { to: 'accountSignature', label: 'Firma Corporativa' },
                    { to: 'changePassword', label: 'Cambiar Contraseña' }
                ]
            };
        },
        computed: {
            ...mapGetters(['user']),
            isAdministrative() {
                return (
                    this.user &&
                    this.user.profile &&
                    this.user.profile.slug === 'administrativo'
                );
            },
            filteredOptions() {
                return this.options.filter(
                    (opt) => opt.to !== 'accountSignature' || this.isAdministrative
                );
            }
        }
    };
</script>